// TODO: вынести в env
const WIDGET_ID = '7f133843a02769da0e4e8359790cec58';
export const TEST_HOST = ['test.atez.ru'];
const PROD_HOST = 'atez.ru';

declare global {
    interface Window {
        TalkMe: any;
        TalkMeSetup?: {clientId?: string};
        supportAPIMethod?: string;
    }
}

function isAllowedHost(): boolean {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    return TEST_HOST.includes(host) || host === PROD_HOST;
}

export function initTalkMeChat(clientId?: string) {
    if (typeof window === 'undefined') return;
    if (!isAllowedHost()) return;

    if (document.getElementById('supportScript')) {
        return;
    }

    // Устанавливаем clientId ДО загрузки скрипта
    if (clientId) {
        window.TalkMeSetup = {clientId};
    }

    (function c(d: Document, w: Window, m: string, i?: boolean) {
        (w as any).supportAPIMethod = m;

        (w as any)[m] = (w as any)[m]
            ? (w as any)[m]
            : function () {
                  ((w as any)[m].q = (w as any)[m].q ? (w as any)[m].q : []).push(arguments);
              };

        const s = d.createElement('script');
        s.id = 'supportScript';
        s.src =
            (!i
                ? 'https://lcab.talk-me.ru/support/support.js'
                : 'https://static.site-chat.me/support/support.int.js') +
            '?h=' +
            WIDGET_ID;
        s.onerror = i
            ? null
            : function () {
                  c(d, w, m, true);
              };

        (d.head || d.body).appendChild(s);
    })(document, window, 'TalkMe');

    // Скрываем виджет по умолчанию до авторизации
    window.TalkMe('hideTrigger');
}

export function isWidgetAvailable(): boolean {
    return isAllowedHost();
}

// Показать виджет
export function showTalkMeWidget() {
    if (typeof window === 'undefined') return;
    document.body.classList.add('talkme-visible');
    window.TalkMe?.('showTrigger');
}

// Скрыть виджет
export function hideTalkMeWidget() {
    if (typeof window === 'undefined') return;
    document.body.classList.remove('talkme-visible');
    window.TalkMe?.('hideTrigger');
}

/** Открыть окно чата (кнопка «Написать» / соц-кнопка у контактов). */
export function openTalkMeSupport(): void {
    if (typeof window === 'undefined' || !isAllowedHost()) return;
    document.body.classList.add('talkme-visible');
    window.TalkMe?.('openSupport');
}

// Передача данных пользователя
export function setTalkMeClientInfo(
    displayName?: string,
    clientName?: string,
    login?: string,
    mrk?: string,
    callback?: (error?: Error) => void
) {
    if (typeof window === 'undefined' || !window.TalkMe) return;

    window.TalkMe(
        'setClientInfo',
        {
            name: displayName ?? '',
            custom: {
                clientName: clientName ?? '',
                clientId: login ?? '',
                mrk: mrk ?? ''
            }
        },
        callback
    );
}
